function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 125,
  r: 100,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "border",
  cx: 125,
  cy: 125,
  r: 105,
  stroke: "white",
  strokeWidth: 10
})), /*#__PURE__*/React.createElement("circle", {
  cx: 72.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.187 151.5C147.293 151.5 149.05 153.248 148.386 155.247C148.096 156.121 147.703 156.98 147.211 157.814C146.03 159.816 144.299 161.635 142.117 163.167C139.935 164.699 137.344 165.915 134.493 166.744C131.642 167.573 128.586 168 125.5 168C122.414 168 119.358 167.573 116.507 166.744C113.656 165.915 111.065 164.699 108.883 163.167C106.701 161.635 104.97 159.816 103.789 157.814C103.297 156.98 102.904 156.121 102.614 155.247C101.95 153.248 103.707 151.5 105.813 151.5C107.919 151.5 109.575 153.288 110.513 155.173C110.612 155.372 110.719 155.57 110.834 155.765C111.632 157.118 112.801 158.346 114.275 159.381C115.749 160.416 117.499 161.237 119.425 161.797C121.351 162.357 123.415 162.646 125.5 162.646C127.585 162.646 129.649 162.357 131.575 161.797C133.501 161.237 135.251 160.416 136.725 159.381C138.199 158.346 139.368 157.118 140.166 155.765C140.281 155.57 140.388 155.372 140.487 155.173C141.425 153.288 143.081 151.5 145.187 151.5Z",
  fill: "#4F4D48"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -13,
  y: -10,
  width: 276,
  height: 276,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-14 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 250,
  fill: "white"
})));

var SvgHappyFace = function SvgHappyFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappyFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Happy Face.35cd6130.svg";
export { ForwardRef as ReactComponent };